// import React, { useEffect, useRef } from 'react';
// import { htmlToText } from 'html-to-text';
// import hljs from 'highlight.js';
// // import 'highlight.js/styles/github.css'; for white theme
// import 'highlight.js/styles/atom-one-dark.css';//for black theme


// const CodeHighlighter = ({ codeHtml,padding }) => {
//   const codeRef = useRef(null);

//   // Convert Quill HTML → plain text
//   const plainCode = htmlToText(codeHtml || '', { wordwrap: false }) || "// No code content provided";

//   // Highlight after render
//   useEffect(() => {
//     if (codeRef.current) {
//       hljs.highlightElement(codeRef.current);
//     }
//   }, [plainCode]);

//   return (
//     <code ref={codeRef} className={`block rounded-[10px] ${padding}`}>
//       {plainCode}
//     </code>
//   );
// };

// export default CodeHighlighter;
import React, { useEffect, useRef } from 'react';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

const CodeHighlighter = ({ codeHtml, padding }) => {
  const codeRef = useRef(null);

  useEffect(() => {
    if (codeRef.current) {
      hljs.highlightElement(codeRef.current);
    }
  }, [codeHtml]);

  // Extract just the text content from the Quill HTML
  const extractCodeText = () => {
    if (!codeHtml) return "// No code content provided";
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = codeHtml;
    
    // Get all .ql-code-block elements and join their text content
    const codeBlocks = tempDiv.querySelectorAll('.ql-code-block');
    const lines = Array.from(codeBlocks).map(block => {
      // Convert <br> to newlines
      if (block.innerHTML === '<br>' || block.innerHTML === '<br/>') {
        return '';
      }
      return block.textContent || '';
    });
    
    return lines.join('\n');
  };

  return (
    // <pre className={`block rounded-[10px] ${padding} overflow-x-auto whitespace-pre`}>
      <code ref={codeRef} className={`block rounded-[10px] ${padding}`}>
        {extractCodeText()}
      </code>
    // </pre>
  );
};

export default CodeHighlighter;